var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCcIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "20px",
    width: "20px",
    fill: "#4c4c4e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 10000 10000",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .fil0 {fill:#4c4c4e;fill-rule:nonzero}\n   \n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M2012 2417l5976 0c430,0 782,351 782,782l0 3602c0,430 -352,782 -782,782l-5976 0c-430,0 -782,-352 -782,-782l0 -3602c0,-431 352,-782 782,-782zm-573 1515l7122 0 0 -733c0,-315 -258,-574 -573,-574l-5976 0c-315,0 -573,259 -573,574l0 733zm7122 209l-7122 0 0 2660c0,315 258,574 573,574l5976 0c315,0 573,-259 573,-574l0 -2660z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "1859,5691 5471,5691 5471,5899 1859,5899 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "1859,6211 5471,6211 5471,6420 1859,6420 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7349 5432c315,0 570,255 570,570 0,315 -255,570 -570,570 -73,0 -143,-13 -207,-38 -66,25 -136,38 -206,38 -315,0 -570,-255 -570,-570 0,-315 255,-570 570,-570 70,0 140,13 206,39 64,-25 134,-39 207,-39zm-442 931c-80,-98 -128,-224 -128,-361 0,-137 48,-262 128,-361 -188,15 -333,173 -333,361 0,189 145,346 333,361zm442 -723c-100,0 -191,41 -256,106 -66,66 -106,156 -106,256 0,200 162,362 362,362 199,0 362,-162 362,-362 0,-200 -162,-362 -362,-362z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcIcon);
export default __webpack_public_path__ + "static/media/cc_icon.53ddfa8c.svg";
export { ForwardRef as ReactComponent };